import React from "react";
import ChampionName from "../misc/ChampionName";
import Circle from "./Circle";
import Champ from "../images/Champ";
import LaneIcon from "../misc/LaneIcon";
import styles from "./Summary.module.css";

export const Summary = ({ mids, summary, width }) => {
  let champions = [];
  let lanes = {
    overall: {
      pick: 0,
      wins: 0,
      losses: 0,
      remakes: 0,
      kp: 0,
      kills: 0,
      deaths: 0,
      assists: 0,
      minions: 0,
      duration: 0,
    },
  };
  mids.forEach((mid) => {
    const key = mid[0];
    if (summary[key] && summary[key].duration > 360) {
      let cid = summary[key].cid;
      let lane = summary[key].lane;

      if (!champions[cid])
        champions[cid] = {
          pick: 0,
          wins: 0,
          losses: 0,
          kp: 0,
          kills: 0,
          deaths: 0,
          assists: 0,
          minions: 0,
          duration: 0,
        };
      if (!lanes[lane])
        lanes[lane] = {
          pick: 0,
          wins: 0,
          losses: 0,
          kp: 0,
          kills: 0,
          deaths: 0,
          assists: 0,
          minions: 0,
          duration: 0,
        };
      champions[cid].pick++;
      champions[cid].kp += summary[key].kp;
      champions[cid].kills += summary[key].kills;
      champions[cid].deaths += summary[key].deaths;
      champions[cid].assists += summary[key].assists;
      champions[cid].minions += summary[key].minions;
      champions[cid].duration += summary[key].duration;
      lanes.overall.pick++;
      lanes.overall.kp += summary[key].kp;
      lanes.overall.kills += summary[key].kills;
      lanes.overall.deaths += summary[key].deaths;
      lanes.overall.assists += summary[key].assists;
      lanes.overall.minions += summary[key].minions;
      lanes.overall.duration += summary[key].duration;
      lanes[lane].pick++;
      lanes[lane].kp += summary[key].kp;
      lanes[lane].kills += summary[key].kills;
      lanes[lane].deaths += summary[key].deaths;
      lanes[lane].assists += summary[key].assists;
      lanes[lane].minions += summary[key].minions;
      lanes[lane].duration += summary[key].duration;
      if (summary[key].win) {
        lanes.overall.wins++;
        champions[cid].wins++;
        lanes[lane].wins++;
      } else {
        lanes.overall.losses++;
        champions[cid].losses++;
        lanes[lane].losses++;
      }
    } else if (summary[key]) lanes.overall.remakes++;
  });

  let tuple = Object.keys(champions).map((cid) => [
    parseInt(cid),
    champions[cid].pick,
  ]);
  tuple.sort(function (a, b) {
    a = a[1];
    b = b[1];
    return a > b ? -1 : a < b ? 1 : 0;
  });

  const data = tuple.slice(0, 3).map((cids, i) => {
    let cid = cids[0];
    if (!champions[cid]) return {};
    return {
      cid: cid,
      pick: champions[cid].pick,
      wins: champions[cid].wins,
      losses: champions[cid].losses,
      kp: Math.round(champions[cid].kp / champions[cid].pick),
      kills: (
        Math.round((champions[cid].kills / champions[cid].pick) * 10) / 10
      ).toFixed(1),
      deaths: (
        Math.round((champions[cid].deaths / champions[cid].pick) * 10) / 10
      ).toFixed(1),
      assists: (
        Math.round((champions[cid].assists / champions[cid].pick) * 10) / 10
      ).toFixed(1),
      kda: champions[cid].deaths
        ? (
            Math.round(
              ((champions[cid].kills + champions[cid].assists) /
                champions[cid].deaths) *
                100
            ) / 100
          ).toFixed(2)
        : "PERFECT",
      cs: Math.round(champions[cid].minions / champions[cid].pick),
      cspm: (
        Math.round((champions[cid].minions / champions[cid].duration) * 600) /
        10
      ).toFixed(1),
      wr: champions[cid].wins
        ? Math.round((champions[cid].wins / champions[cid].pick) * 100)
        : 0,
    };
  });

  let tupleLane = Object.keys(lanes).map((lane) => [lane, lanes[lane].pick]);
  tupleLane.sort(function (a, b) {
    a = a[1];
    b = b[1];
    return a > b ? -1 : a < b ? 1 : 0;
  });

  const laneData = tupleLane.slice(0, 3).map((l, i) => {
    let lane = l[0];
    return {
      lane: lane,
      pick: lanes[lane].pick,
      wins: lanes[lane].wins,
      losses: lanes[lane].losses,
      kp: lanes[lane].kp ? Math.round(lanes[lane].kp / lanes[lane].pick) : 0,
      kills: lanes[lane].kills
        ? (
            Math.round((lanes[lane].kills / lanes[lane].pick) * 10) / 10
          ).toFixed(1)
        : 0,
      deaths: lanes[lane].deaths
        ? (
            Math.round((lanes[lane].deaths / lanes[lane].pick) * 10) / 10
          ).toFixed(1)
        : 0,
      assists: lanes[lane].assists
        ? (
            Math.round((lanes[lane].assists / lanes[lane].pick) * 10) / 10
          ).toFixed(1)
        : 0,
      kda: lanes[lane].deaths
        ? (
            Math.round(
              ((lanes[lane].kills + lanes[lane].assists) / lanes[lane].deaths) *
                100
            ) / 100
          ).toFixed(2)
        : "PERFECT",
      cs: lanes[lane].minions
        ? Math.round(lanes[lane].minions / lanes[lane].pick)
        : 0,
      cspm: lanes[lane].minions
        ? (
            Math.round((lanes[lane].minions / lanes[lane].duration) * 600) / 10
          ).toFixed(1)
        : 0,
      wr: lanes[lane].wins
        ? Math.round((lanes[lane].wins / lanes[lane].pick) * 100)
        : 0,
    };
  });

  return (
    <div className={styles[width]}>
      <div className={styles.data}>
        <div>
          <div></div>
          <div></div>
          <div>Pick</div>
          <div>KDA</div>
          <div>KP</div>
          <div>Win</div>
        </div>
        {laneData.map((row, i) => (
          <div key={row.lane}>
            <div>
              <LaneIcon lane={row.lane !== "overall" ? row.lane : "all"} />
            </div>
            <div>
              <div>
                <div className={styles.name}>{row.lane.toUpperCase()}</div>
                <div>
                  {row.cs} CS ({row.cspm})
                </div>
              </div>
            </div>
            <div>
              <div>{row.pick}</div>
              <div>
                <span className={styles.green}>{row.wins}W</span>{" "}
                <span className={styles.red}>{row.losses}L</span>
              </div>
            </div>
            <div>
              <div className={styles.kda}>{row.kda} KDA</div>
              <div>
                <span className={styles.green}>{row.kills}</span> /{" "}
                <span className={styles.red}>{row.deaths}</span> / {row.assists}
              </div>
            </div>
            <div>{row.kp}%</div>
            <div className={row.wr >= 50 ? styles.green : styles.red}>
              {row.wr}%
            </div>
          </div>
        ))}
      </div>
      {width !== "xsmall" && width !== "tiny" && (
        <div>
          {lanes.overall.pick > 0 && (
            <Circle
              wins={lanes.overall.wins}
              losses={lanes.overall.losses}
              remakes={lanes.overall.remakes}
            />
          )}
        </div>
      )}
      <div className={styles.data}>
        <div>
          <div></div>
          <div></div>
          <div>Pick</div>
          <div>KDA</div>
          <div>KP</div>
          <div>Win</div>
        </div>
        {data.map((row, i) => (
          <div key={row.cid}>
            <div>
              <Champ type="champ30b" id={row.cid} />
            </div>
            <div>
              <div>
                <div className={styles.name}>
                  <ChampionName cid={row.cid} />
                </div>
                <div>
                  {row.cs} CS ({row.cspm})
                </div>
              </div>
            </div>
            <div>
              <div>{row.pick}</div>
              <div>
                <span className={styles.green}>{row.wins}W</span>{" "}
                <span className={styles.red}>{row.losses}L</span>
              </div>
            </div>
            <div>
              <div className={styles.kda}>{row.kda} KDA</div>
              <div>
                <span className={styles.green}>{row.kills}</span> /{" "}
                <span className={styles.red}>{row.deaths}</span> / {row.assists}
              </div>
            </div>
            <div>{row.kp}%</div>
            <div className={row.wr >= 50 ? styles.green : styles.red}>
              {row.wr}%
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Summary;
